import { render, staticRenderFns } from "./GlobalRatingConf.vue?vue&type=template&id=4fa1818c"
import script from "./GlobalRatingConf.vue?vue&type=script&lang=js"
export * from "./GlobalRatingConf.vue?vue&type=script&lang=js"
import style0 from "./GlobalRatingConf.vue?vue&type=style&index=0&id=4fa1818c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports